/**
 * Reconstructs a viewable URL for a stored attachment `key`, and infers a MIME type from a
 * filename — the two things history rendering needs that the persisted `image-upload`
 * payload does not carry.
 *
 * The Cimpress Documents URL pattern is duplicated here (rather than imported from
 * `design-services-common`, where `getVariantUrl` also lives) to keep the library free of
 * that dependency — see `upload/types.ts` for why the upload backend is held at arm's
 * length. It is a stable public URL convention; the same constants back the uploader that
 * produced the `key` in the first place.
 */
const CIMPRESS_DOCUMENTS_URL = 'https://uploads.documents.cimpress.io/v1/uploads';
const TENANT = 'designtechprod';

export type AttachmentVariant = 'preview' | 'original';

export function getVariantUrl(uploadId: string, variant: AttachmentVariant): string {
    return `${CIMPRESS_DOCUMENTS_URL}/${uploadId}/${variant}?tenant=${TENANT}`;
}

const EXTENSION_TO_MIME: Record<string, string> = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    bmp: 'image/bmp',
    pdf: 'application/pdf',
    doc: 'application/msword',
};

/** Best-effort MIME type from a filename extension; `application/octet-stream` when unknown. */
export function mediaTypeFromFileName(fileName: string): string {
    const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
    return EXTENSION_TO_MIME[ext] ?? 'application/octet-stream';
}
